/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataLoaderStatus {
    Enqueued = 0,
    InProgress = 1,
    Finished = 2,
    Error = 3,
    Deleting = 4,
    Paused = 5,
    WaitingForUpload = 6,
}
